;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.creditnote.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider', 'populates']

  function RouteConfigurator ($stateProvider, populates) {
    const baseState = {
      // Retire le watcher $rootScope de la pagination résolue à la sortie de l'état
      // (baseState est recopié dans chaque état : chacun résout et détruit la sienne)
      onExit: ['creditNotePagination', function (creditNotePagination) { creditNotePagination.destroy() }],
      resolve: {
        model: () => 'creditNote',
        fromQuote () {},
        fromToDeposit () {},
        template: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCreditNotePrefs().then(function (prefs) {
            return prefs.numberFormat
          })
        }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams
        }],
        creditNotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp-creditNoteList', { perPage: 5 })
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(
            CustomFieldManager
              .query()
              .select('creditnote', 'model')).then(function (data) {
            return data.data
          })
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats
          })
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs()
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/creditnote/show/templates/creditnote-show.template.html',
          controller: 'ElementShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/creditnote/show/templates/creditnote-show-toolbar.html',
          controller: 'CreditNoteShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.status === \'draft\' ? toolbar.title : toolbar.number | truncate: 50}}' + '{{toolbar.status === \'draft\' ? \' (Brouillon)\' : \'\'}}',
        parent: 'creditnote.list'
      }
    }

    const showState = {
      ...baseState,
      name: 'creditnote.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        ...baseState.resolve,
        element: ['$stateParams', 'CreditNoteManager', function ($stateParams, CreditNoteManager) {
          return CreditNoteManager.findById($stateParams.id, CreditNoteManager.query({
            populate: JSON.stringify(populates.show.creditNote)
          }))
        }]
      }
    }

    const newState = {
      ...baseState,
      name: 'creditnote.new',
      url: '/new',
      resolve: {
        ...baseState.resolve,
        element: ['CreditNoteService', function (CreditNoteService) {
          return CreditNoteService.createCreditNoteFromPreferences()
        }]
      },
      ncyBreadcrumb: {
        ...baseState.ncyBreadcrumb,
        label: 'Création d\'un avoir'
      }
    }

    $stateProvider
      .state(showState)
      .state(newState)
  }
})(window.angular, window._, window.moment)
